import { MaintenanceModel, MaintenanceRecurrenceModel } from 'api/models';
import { createSelector } from 'reselect';
import { AppState } from '../types';
import { MAINTENANCE_REDUCER } from './reducer';

const _selectAccounts = (state: AppState) => state[MAINTENANCE_REDUCER];

const _selectCurrentTask = (state: AppState) =>
  _selectAccounts(state).currentTask;

const _selectHomeownerTasks = (
  state: AppState,
): MaintenanceModel[] | undefined => _selectAccounts(state).homeTasks;

const _selectRentTasks = (state: AppState): MaintenanceModel[] | undefined =>
  _selectAccounts(state).rentTasks;
const _selectImprovementsReport = (state: AppState) =>
  _selectAccounts(state).improvementsReport;

export const selectHomeownerTasks = createSelector(
  _selectHomeownerTasks,
  (tasks) => tasks ?? [],
);

export const selectRentTasks = createSelector(_selectRentTasks, (tasks) =>
  Array.isArray(tasks) ? tasks : [],
);

export const selectCurrentTask = createSelector(
  _selectCurrentTask,
  (task) => task ?? {},
);

const _selecteMaintenances = (state: AppState) =>
  _selectAccounts(state).taskById;

// Callers pass an id derived from an optional model field, so the parameter is
// widened to match. Indexing with `undefined` previously read the literal
// `"undefined"` key, which no task id can be, so this returns what it always did.
export const selectMaintenanceById = (uniqueId: string | undefined) =>
  createSelector(_selecteMaintenances, (tasks): MaintenanceModel | undefined =>
    uniqueId ? tasks?.[uniqueId] : undefined,
  );

// Not `| undefined`: the reducer seeds `recurringTasks` to `[]` and only ever
// replaces it with an array, so this slice is never absent. The three call sites
// already assert as much by asking `useSelector` for a plain array.
export const selectRecurringTasks = (
  state: AppState,
): MaintenanceRecurrenceModel[] => _selectAccounts(state).recurringTasks;
